import { Button, Tooltip } from 'antd';

import useLocale from '../../../hooks/useLocale';
import type { CommandAction, CommandStatus } from './types';
import { getActionBlock, getActionBlockText } from './utils';

interface IProps {
  action: CommandAction;
  statuses: ReadonlyArray<CommandStatus | undefined>;
  label: string;
  onClick: () => void;
}

// The button is enabled only when every command can take the action; the tooltip says why it is not.
const CommandActionButton = ({ action, statuses, label, onClick }: IProps): JSX.Element => {
  const { t } = useLocale();
  const block = getActionBlock(action, statuses);

  return (
    <Tooltip title={block && getActionBlockText(block, action, t)}>
      <Button danger={action === 'cancel'} disabled={block !== undefined} onClick={onClick}>
        {label}
      </Button>
    </Tooltip>
  );
};

export default CommandActionButton;
